import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Check Circle icon for completion and success
 */
export const CheckCircleIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
      <polyline points="22 4 12 14.01 9 11.01"></polyline>
    </Icon>
  );
};

export default CheckCircleIcon;
